export const TEMPLATE_VAR_REGEX = /#\!([a-zA-Z0-9_-]+)\!#/gi;
export const TEMPLATE_VAR_REGEX_NON = /#\!([a-zA-Z0-9_-]+)\!#/i;
export const TEMPLATE_VAR_SQR = /\[#\!([a-zA-Z0-9_-]+)\!#\]/i;
export const IS_JSONPATH_REGEX = /^\$$|^\$\./;
export const IS_JSONPATH_FILTER_REGEX = /\[?\?\(.+?\)\]?/gi;
// export const IS_JSONPATH_FILTER_OBJ_KEY
